import { NgModule } from '@angular/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { PageTitleModule } from 'app/layout/components/page-title/page-title.module';
import { CompanyComponent } from 'app/main/company/company.component';
import { CompanyResolver } from 'app/main/company/company.resolver';
import { MaterialModule } from 'app/main/material.module';

import { Effects } from './effects';
import { reducers } from './reducers';

@NgModule({
    declarations: [
        CompanyComponent,
    ],
    imports     : [
        FuseSharedModule,
        MaterialModule,
        PageTitleModule,
        StoreModule.forFeature('company', reducers),
        EffectsModule.forFeature(Effects),
    ],
    exports     : [
        CompanyComponent,
    ],
    providers: [
        CompanyResolver
    ]
})

export class CompanyModule
{
}
